export default __webpack_public_path__ + "static/media/Microcef-400-ban.7c6fa1fe.jpg";